"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Audit/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');






var _peers = require('shared/selectors/peers');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _routes = require('web/chat/routes');
var _Avatar = require('web/components/Avatar');
var _DataTable = require('web/components/DataTable');
var _useAuditExport = require('web/components/Audit/useAuditExport');
var _format = require('web/components/Audit/format');
var _hooks = require('web/services/hooks');

var _EventSheet = require('./EventSheet'); var _EventSheet2 = _interopRequireDefault(_EventSheet);
var _FilterBar = require('./FilterBar'); var _FilterBar2 = _interopRequireDefault(_FilterBar);
var _filters = require('./filters');
var _ScrollLoader = require('./ScrollLoader'); var _ScrollLoader2 = _interopRequireDefault(_ScrollLoader);
var _useAuditLog = require('./useAuditLog');






const rowKey = (e) => e.AuditKey
const rowLabel = (e) => `${e.ActionLabel} by ${e.Person.Name}, ${_format.formatEventTime.call(void 0, e.OccurredAt)}`

// Only Time sorts: the log is stored by time, so both orders read a bounded
// number of rows on any range.


const COLUMNS = [
  { id: 'time', label: 'Time', width: 155, sort: 'time', cell: e => _react2.default.createElement('span', { className: "audit-cell--time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}},  _format.formatEventTime.call(void 0, e.OccurredAt) ) },
  // Wide enough for an organization's whole name at desktop widths (AU-1).
  { id: 'org', label: 'Organization', width: 200, cell: e => _react2.default.createElement('span', { title: e.OrgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}},  e.OrgName ) },
  {
    id: 'person',
    label: 'Person',
    width: 160,
    cell: e => (
      _react2.default.createElement('div', { className: "audit-person", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        /* SAFETY: the avatar only looks the key up; Support and system actors have none and get the default. */
        , _react2.default.createElement(_Avatar.UserAvatar, { userKey: (e.Person.UserKey || e.AuditKey) , size: 28, noOnlineIndicator: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
        , _react2.default.createElement('div', { className: "account-people--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          , _react2.default.createElement('span', { className: "audit-person--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}},  e.Person.Name )
          ,  (e.Person.IsSupport || e.Person.Role) && (
            _react2.default.createElement('span', { className: "account-people--email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}},  e.Person.IsSupport ? 'BloomText staff' : e.Person.Role )
          )
        )
      )
    ),
  },
  { id: 'action', label: 'Action', width: 145, cell: e => _react2.default.createElement('span', { className: `audit-chip ${_format.actionChipClass.call(void 0, e.Action)}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}},  e.ActionLabel ) },
  { id: 'patient', label: 'Patient', width: 115, cell: e => _nullishCoalesce(_optionalChain([e, 'access', _ => _.Patient, 'optionalAccess', _2 => _2.Name]), () => ( _react2.default.createElement('span', { className: "dir-cell--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, "—"))) },
  { id: 'details', label: 'Details', cell: e => _nullishCoalesce([e.Details, e.ChatName].filter(Boolean)[0], () => ( '')) },
]

const initialFilters = (search) => {
  // SAFETY: the param is a patient key, written by the patient's Access history.
  const patientKey = new URLSearchParams(search).get(_routes.AUDIT_PATIENT_PARAM)
  return patientKey ? { ..._filters.DEFAULT_FILTERS, patient: { patientKey: patientKey , name: '' } } : _filters.DEFAULT_FILTERS
}

/* Settings → Account → Audit (screens A, B, D): the account's audit log
 * with its filters and Download CSV, newest first or oldest first by the
 * Time header, loading the next page as it scrolls. A row opens the event
 * in a side sheet. No total count: the header says how many events are
 * showing. */
const AuditTab = ({ orgKey, account }) => {
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const [filters, setFilters] = _react.useState(() => initialFilters(search))
  const [oldest, setOldest] = _react.useState.call(void 0, false)
  const log = _useAuditLog.useAuditLog.call(void 0, orgKey, filters, oldest)
  const csv = _useAuditExport.useAuditExport.call(void 0, log.reload)

  const [options, setOptions] = _react.useState(null)
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    _actions2.default.getAuditLogFilters({ OrgKey: orgKey })
      .then(o => { if (isCurrent) setOptions(o) })
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [orgKey])

  // A link names only the patient's key: their name comes from the
  // Directory's copy, or from their events.
  const linkedKey = filters.patient && !filters.patient.name ? filters.patient.patientKey : null
  const storedName = _hooks.useAppSelector.call(void 0, s => linkedKey ? _nullishCoalesce(_optionalChain([_peers.selectPatientByKey.call(void 0, s, linkedKey), 'optionalAccess', _3 => _3.Name]), () => ( '')) : '')
  const eventName = linkedKey ? _nullishCoalesce(_optionalChain([log, 'access', _4 => _4.events, 'access', _5 => _5.find, 'call', _6 => _6(e => _optionalChain([e, 'access', _7 => _7.Patient, 'optionalAccess', _8 => _8.PatientKey]) === linkedKey), 'optionalAccess', _9 => _9.Patient, 'optionalAccess', _10 => _10.Name]), () => ( '')) : ''
  const shownFilters = _react.useMemo.call(void 0, 
    () => filters.patient && !filters.patient.name
      ? { ...filters, patient: { ...filters.patient, name: storedName || eventName || 'this patient' } }
      : filters,
    [filters, storedName, eventName],
  )

  const [openKey, setOpenKey] = _react.useState(null)
  const openEvent = _nullishCoalesce(log.events.find(e => e.AuditKey === openKey), () => ( null))
  const openPatient = _optionalChain([openEvent, 'optionalAccess', _11 => _11.Patient])
  const onOpen = _react.useCallback.call(void 0, (e) => setOpenKey(e.AuditKey), [])
  const onClose = _react.useCallback.call(void 0, () => setOpenKey(null), [])
  const sort = _react.useMemo(() => ({ sort: 'time', desc: !oldest }), [oldest])
  const onSort = _react.useCallback.call(void 0, () => {
    setOldest(o => !o)
    setOpenKey(null)
  }, [])

  const onFilters = _react.useCallback.call(void 0, (f) => {
    setFilters(f)
    setOpenKey(null)
  }, [])
  const clearFilters = _react.useCallback.call(void 0, () => onFilters(_filters.DEFAULT_FILTERS), [onFilters])

  const count = log.events.length
  const showing = `Showing ${_format.formatCount.call(void 0, count)} ${count === 1 ? 'event' : 'events'}`
  const isFailed = log.hasError && count === 0

  return (
    _react2.default.createElement('div', { className: "audit-tab", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
      , _react2.default.createElement('div', { className: "audit-tab--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
        , _react2.default.createElement('h2', { className: "audit-tab--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "Audit log" )
        ,  log.hasLoaded && _react2.default.createElement('span', { className: "audit-tab--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}},  showing ) 
        , _react2.default.createElement('button', {
          type: "button",
          className: "blm-btn blm-btn--secondary audit-csv"  ,
          disabled: csv.isPreparing,
          onClick: () => csv.start(_filters.auditRequest.call(void 0, orgKey, filters)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}

          , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-download-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
          ,  csv.isPreparing ? 'Preparing CSV…' : 'Download CSV' 
        )
      )
      , _react2.default.createElement(_FilterBar2.default, {
        filters: shownFilters,
        onFilters: onFilters,
        options: options,
        orgKeys: account.OrgKeys, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
      )
      ,  isFailed
        ? (
            _react2.default.createElement('div', { className: "audit-empty", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
              , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}, "Couldn't load the audit log"    )
              , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}, "Check your connection and try again."     )
              , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: log.reload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}, "Try again" )
            )
          )
        : (
            _react2.default.createElement('div', { className: "data-table audit-table" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
              , _react2.default.createElement(_DataTable.DataTableGrid, {
                label: "Audit log" ,
                columns: COLUMNS,
                rows: log.events,
                rowKey: rowKey,
                rowLabel: rowLabel,
                sort: sort,
                onSort: onSort,
                // Placeholders only before the first page; the next pages
                // load under the rows.
                isLoading: !log.hasLoaded,
                isBusy: log.isLoading,
                onOpen: onOpen,
                openKey: openEvent ? openKey : null,
                footer: log.hasLoaded && (
                  _react2.default.createElement(_ScrollLoader2.default, {
                    hasMore: log.hasMore,
                    isLoading: log.isLoading,
                    hasError: log.hasError,
                    hasRows: count > 0,
                    emptyPages: log.emptyPages,
                    onLoad: log.loadMore,
                    onKeepSearching: log.keepSearching, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
                  )
                ),
                emptyState: log.hasLoaded && !log.isLoading && !log.hasMore && (_filters.hasFilters.call(void 0, filters)
                  ? (
                      _react2.default.createElement('div', { className: "audit-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
                        , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}, "No events match these filters"    )
                        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}, "Try a longer date range, or clear a filter."        )
                        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: clearFilters, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}, "Clear filters" )
                      )
                    )
                  : (
                      _react2.default.createElement('div', { className: "audit-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}
                        , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}, "No events in the last 30 days"      )
                        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}, "The audit log records sign-ins, chat views, exports, and settings and role changes from the day it was turned on."                   )
                      )
                    )), __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}
              )
            )
          )
      ,  openEvent && (
        _react2.default.createElement(_EventSheet2.default, {
          event: openEvent,
          onClose: onClose,
          onMoreFromPerson: openEvent.Person.IsSupport
            ? () => onFilters({ ...filters, person: { kind: 'support' } })
            // SAFETY: a non-empty UserKey is the person's.
            : openEvent.Person.UserKey
              ? () => onFilters({ ...filters, person: { kind: 'user', userKey: openEvent.Person.UserKey , name: openEvent.Person.Name } })
              : undefined,
          onMoreForPatient: openPatient
            ? () => onFilters({ ...filters, patient: { patientKey: openPatient.PatientKey, name: openPatient.Name } })
            : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}
        )
      )
      , _react2.default.createElement(_useAuditExport.AuditExportToast, { state: csv.state, dismiss: csv.dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}} )
    )
  )
}

exports. default = AuditTab
